import React from "react";
import { Props } from "./types";
import { Button, HStack, Text, VStack } from "@chakra-ui/react";
import { formatDate } from "src/common";
import { ProfileImage } from "semente-js";

const NoteBox: React.FC<Props> = ({ handleClick, ...note }) => {
  return (
    <Button
      p={"16px"}
      borderRadius={"16px"}
      border={"1px solid"}
      borderColor={"Gray.$200"}
      height={"168px"}
      alignItems={"flex-start"}
      w="100%"
      flexDirection={"column"}
      background={"transparent"}
      _hover={{
        background: "Gray.$200",
      }}
      onClick={handleClick}
    >
      <VStack width={"100%"} h={"100%"} alignItems={"flex-start"}>
        <Text
          fontSize={"16px"}
          fontWeight={600}
          width={"100%"}
          textAlign={"left"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
        >
          {note.title}
        </Text>

        <Text
          dangerouslySetInnerHTML={{ __html: note.description }}
          mt={"4px"}
          fontSize={"14px"}
          fontWeight={400}
          width={"100%"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
          whiteSpace={"normal"}
          textAlign={"left"}
          maxH={"50px"}
        />
      </VStack>

      <VStack mt={"16px"}>
        <HStack>
          <ProfileImage
            initials={`${note.createdBy?.name.substring(0, 1)}${note.createdBy?.surname.substring(0, 1)}`}
          />
          <VStack alignItems={"flex-start"} spacing={0}>
            <Text fontSize={"12px"} fontWeight={600}>
              {note.createdBy?.name} {note.createdBy?.surname}
            </Text>

            <Text fontSize={"12px"} fontWeight={400}>
              {formatDate(new Date(note.createdAt), "dd/MM/yyyy")}
            </Text>
          </VStack>
        </HStack>
      </VStack>
    </Button>
  );
};

export default NoteBox;
